import { FiInfo } from "react-icons/fi";
import { describeLoanType } from "./loanTypeModel";
import "./loan.css";

/**
 * Shown under a loan type picker: what the loan costs and, in plain words, how repayment works.
 * Pass `durationType` once the user has chosen a unit so the wording says "per month", not "per period".
 */
export default function LoanTypeSummary({ loanType, durationType, variant = "default", className = "" }) {
  const audience = variant === "calculator" ? "calculator" : "default";
  const info = describeLoanType(loanType, { durationType, audience });
  if (!info || !(info.name || info.facts.length)) return null;

  return (
    <section className={`lt ${className}`} aria-label={`${info.name || "Loan type"} details`}>
      <div className="lt-head">
        <span className="lt-ico">
          <FiInfo size={18} aria-hidden="true" />
        </span>
        <div style={{ minWidth: 0 }}>
          <p className="lt-name">{info.name || "Loan type"}</p>
          <p className="lt-sub">Loan type details</p>
        </div>
        <span className="lt-pill">{info.modelLabel}</span>
      </div>

      {info.facts.length ? (
        <dl className="lt-facts">
          {info.facts.map((fact) => (
            <div key={fact.key} className="lt-fact">
              <dt>{fact.label}</dt>
              <dd>
                {fact.value}
                {fact.hint ? <small>{fact.hint}</small> : null}
              </dd>
            </div>
          ))}
        </dl>
      ) : null}

      {info.steps.length ? (
        <div className="lt-how">
          <h4>How repayment works</h4>
          <ol>
            {info.steps.map((step) => (
              <li key={step}>{step}</li>
            ))}
          </ol>
        </div>
      ) : null}

      {info.rangeNote ? <p className="lt-note">{info.rangeNote}</p> : null}
    </section>
  );
}
